import {useTranslation} from "react-i18next";
import Button from "../../../core/Button/Button";
import {useDispatch, useSelector} from "react-redux";
import React from "react";
import {cleanUpHistoryRooms, roomEnter} from "../../../redux/actions/rooms/actions.js";
import {getHistorySelectedRoomActions} from "../../../redux/actions/history/actions.js";
import {selectActiveRoomTab} from "../../../redux/actions/lobby/actions.js";

function HistoryInfo() {
    const {t} = useTranslation();
    const currency = useSelector(state => state.user.currency);
    const {selectedRoomId, selectedRoomInfo, selectedRooms} = useSelector(state => state.history);
    const dispatch = useDispatch();

    const openHistoryRoom = () => {
        dispatch(cleanUpHistoryRooms());
        if (selectedRooms?.[selectedRoomId]) {
            dispatch(roomEnter({
                roomId: selectedRoomId,
                status: selectedRoomInfo.status,
                isViewRoom: true,
                historyRoomPlayer: true,
                tournamentId: null,
                notifier: false
            }));
            dispatch(selectActiveRoomTab({roomId: selectedRoomId}));
            return;
        }
        dispatch(getHistorySelectedRoomActions({roomId: selectedRoomId}))
    }

    return (
        <div className="history-info">
            <div className="history-info__wrapper">
                <div className="history-info__header">Խաղի ID {selectedRoomInfo?.table_history_game_id || ""}</div>
                <div className="history-info__content">
                    <div className="history-info__row">
                        <span>{t("history.game_id")}</span>
                        {selectedRoomInfo && selectedRoomInfo?.table_history_game_id}
                    </div>
                    <div className="history-info__row">
                        <span>{t("history.bet")}</span>
                        {selectedRoomInfo && <p>{(selectedRoomInfo?.table_history_bet[currency])?.toFixed(2)} <span
                            className="currency-small">{currency}</span></p>}
                    </div>
                    <div className="history-info__row">
                        <span>{t("history.opponent")}</span>
                        {selectedRoomInfo && selectedRoomInfo?.table_history_opponent}
                    </div>
                    <div className="history-info__row">
                        <span>{t("history.till")}</span>
                        {selectedRoomInfo && selectedRoomInfo?.table_history_till}
                    </div>
                    <div className="history-info__row">
                        <span>{t("history.score")}</span>
                        {selectedRoomInfo && selectedRoomInfo?.table_history_points}
                    </div>
                    <div className="history-info__row">
                        <span>{t("history.step_time")}</span>
                        {selectedRoomInfo && `${selectedRoomInfo?.table_history_step_time}${t('history.s')}`}
                    </div>
                    <div className="history-info__row">

                        <span>{t("history.type")}</span>
                        <span>
                            {
                                selectedRoomInfo?.table_history_conventions?.map((item, index) => {
                                    return <i
                                        key={`icon-${item}${index}`}
                                        className={`icon-${item} table-icon`}
                                    />
                                })
                            }
                        </span>
                    </div>
                    <div className="history-info__row">
                        <span>{t("history.result")}</span>
                        {selectedRoomInfo && t(`history.${selectedRoomInfo?.table_history_result}`)}
                    </div>
                </div>
                {
                    selectedRoomId &&
                    <>
                        <div className="history-info__footer">
                            <Button text={t("buttons.view")} onClick={() => openHistoryRoom()}/>
                        </div>
                    </>
                }
            </div>
        </div>
    )
}

export default HistoryInfo